<template>
  <thead>
    <tr class="trTotal">
      <th
        class="bordazIndex text-left text-dark"
        style="z-index: 3 !important">
        <div class="resGeralAling">
          <nobr>
            <span>
              <strong class="p-3" style="font-size: 12px">
                TOTAL
              </strong>
            </span>
          </nobr>
          <span
            class="text-right w-100 d-block pr-4">
            {{ totalVidas(cenarios) }}
          </span>
        </div>
      </th>
      <template v-for="(operadora, indexo) in cenarios[0].operadoras">
        <b-th
          class="alinharValores text-dark"
          v-for="(plano, p) in parsePlanos(operadora.grupos)"
          :key="`total-${indexo}-${plano.id}-${p}`">
          {{ totalValor(plano, cenarios) | dinheiro }}
        </b-th>
      </template>
    </tr>
    <tr>
      <td
        class="text-left text-dark"
        style="z-index: 3 !important"
        :colspan="gerarColspan(cenarios[0].operadoras)">
        <div class="row" id="row-detalhamento" :style="verificarDetalhamento(cenarios[0].operadoras)">
          <div class="col-md-3"><span>* Clique para ver o detalhamento</span></div>
        </div>
      </td>
    </tr>
  </thead>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters("cenario", {
      cenarios: "getCenarios"
    }),
  },
  methods: {
    totalVidas(cenarios) {
      let vidas = 0
      cenarios.forEach(c => {
        vidas += c.faixas
          .map(f => Number(f.value))
          .reduce((o, c) => parseInt(o) + parseInt(c))
      })
      return vidas
    },
    totalValor(plano, cenarios) {
      let total = 0.00;
      cenarios.forEach(c => {
        c.operadoras.forEach(o => {
          o.grupos.forEach(g => {
            let p = g.planos.find(
              p => parseInt(p.key_operadora) == parseInt(plano.key_operadora)
               && parseInt(p.key_grupo) == parseInt(plano.key_grupo)
               && parseInt(p.key_plano) == parseInt(plano.key_plano)
               && p.modalidade == plano.modalidade
            )
            if (p) {
              total += p.filtros.regras_aceitacao && (p.alertas && p.alertas.length > 0)
                ? 0
                : p.taxas.iof == true ? parseFloat(p.calculo.total_iof) : parseFloat(p.calculo.total)
            }
          })
        })
      })
      return total
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, [])
    },
    gerarColspan(operadoras) {
      let cspan = 1;
      if(operadoras.length > 0) {
        operadoras.forEach(o => {
          o.grupos.forEach(g =>{
            cspan += g.planos.length;
          });
        })
      }

      return cspan;
    },
    verificarDetalhamento(operadoras) {
      let exibir = false;
      if(operadoras.length > 0) {
        operadoras.forEach(o => {
          o.grupos.forEach(g => {
            g.planos.forEach(p => {
              if(!exibir && typeof p.calculo.taxa_descricao === 'string' && p.calculo.taxa_descricao.length > 0) {
                exibir = true;
              }
            });
          })
        })
      }
      return exibir ? 'display:flex' : 'display:none';
    }
  }
}
</script>

<style>
.taxa_descricao {
  max-width: initial;
}
</style>
